module.exports = __webpack_public_path__ + "static/media/5eadc67c00e6c6bc41ea0c70_Facebook 2.cb8447ba.svg";